import React from 'react';

import { ITestProps } from '../utils/dataTest';

import { Description } from '../Description';
import { Header } from '../Header';
import { LoadingBlock } from '../LoadingBlock';

import styles from './BasicCard.module.scss';

export interface IBasicCardProps extends ITestProps {
  /** Text for card title */
  title: string;
  /** Text for card description */
  content?: string;
  /** Icon displayed on left of card */
  icon?: React.ReactNode;
  /** If set, the maximum number of lines to render */
  maxContentLines?: number;
  isLoading?: boolean;
  /** A function that is called on click event */
  onClick?(): void;
}

export const BasicCard: React.FC<IBasicCardProps> = (props) => {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (props.onClick) {
        props.onClick();
      }
    }
  };

  const title = props.isLoading ? <LoadingBlock /> : props.title;
  const content = props.isLoading ? (
    <LoadingBlock className={styles.loadingContent} />
  ) : (
    props.content && (
      <div className={styles.content}>
        <Description variant="condensed" dataTest="content" maxLines={props.maxContentLines}>
          {props.content}
        </Description>
      </div>
    )
  );

  return (
    <div
      className={styles.basicCard}
      role="button"
      tabIndex={0}
      data-test={props.dataTest}
      onClick={props.onClick}
      onKeyPress={handleKeyPress}
    >
      {!props.isLoading && props.icon && <div className={styles.icon}>{props.icon}</div>}
      <div className={styles.contentWrapper}>
        <Header variant="h4" dataTest="title">
          {title}
        </Header>
        {content}
      </div>
    </div>
  );
};
